function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSelecct = function SvgSelecct(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M0 0h20v20H0z"
  }), React.createElement("path", {
    d: "M8 16a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zM8 2a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6z",
    transform: "translate(2 2)",
    style: {
      fill: "#ff6452"
    }
  }), React.createElement("path", {
    "data-name": "Path 918",
    d: "M3 0a3 3 0 1 1-3 3 3 3 0 0 1 3-3z",
    transform: "translate(7 7)",
    style: {
      fill: "#ff6452"
    }
  }));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSelecct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selecct.3b2cc5ec.svg";
export { ForwardRef as ReactComponent };